import { FieldsetHTMLAttributes, ReactNode } from 'react';

export interface FieldsetProps
  extends FieldsetHTMLAttributes<HTMLFieldSetElement> {
  label?: string | ReactNode;
  showLabelAsterisk?: boolean;
  /** Callback function called when the label is clicked */
  onLabelClick?: (e: React.MouseEvent<HTMLLegendElement>) => void;
  children?: ReactNode;
  errorMessage?: string;
  className?: string;
  dataHook?: string;
  /** Provide id for field to use with aria-labelledby. */
  labelId?: string;
  /** Provide id for error message to use with aria-describedby. */
  errorMessageId?: string;
}

export const FieldsetDataHooks = {
  Error: 'fieldset-error',
  Label: 'fieldset-label',
  LabelAsterisk: 'fieldset-label-asterisk',
};
